import { EditFilled } from '@ant-design/icons'
import { DataItem, GraviButton, LocationMap } from '@gravitate-js/excalibrr'
import { Button, Col, Row } from 'antd'
import React from 'react'

import { useDestinationsContext } from '../../OrderWizard/Contexts/DestinationsContext'
import { useOrderContainersContext } from '../../OrderWizard/Contexts/OrderContainersContext'

export function StoreCard({ store, destIndex, showMap = true, isEditMode, setIsEditMode, success }) {
  const { removeDestination } = useDestinationsContext()
  const { compartments, setCompartments, productGroupsApi } = useOrderContainersContext()
  const mapCenter = { lat: store.lat, lng: store.lon }
  const googleMap = <LocationMap mapCenter={mapCenter} location={store} />
  const successStyle = success ? 'success' : ''
  const removeClick = () => {
    removeDestination(destIndex, compartments, setCompartments)
    productGroupsApi.deleteAllocationsByStoreNumber(store.store_number)
    setIsEditMode(false)
  }

  return (
    <div className={`store-card ${successStyle}`}>
      {showMap && <div className='store-map'>{googleMap}</div>}
      <div className='store-details-card p-3'>
        <Row>
          <Col span={16}>
            <div className='store-number'>{store.store_number}</div>
          </Col>
          <Col align='right' span={8}>
            {isEditMode ? (
              <Button onClick={() => setIsEditMode(false)} type='text'>
                Cancel
              </Button>
            ) : (
              <Button
                onClick={() => setIsEditMode(true)}
                className='store-edit-button'
                shape='circle'
                icon={<EditFilled />}
              />
            )}
          </Col>
        </Row>
        <Row className={showMap ? 'number-location-tank-row' : ''}>
          <Col span={18} className='store-city'>
            {`${store.city}, ${store.state}`}
          </Col>
          <Col span={6} className='tank-count'>
            {isEditMode ? (
              <GraviButton error buttonText='Remove' onClick={() => removeClick()} />
            ) : (
              `${store.tank_count} Tanks`
            )}
          </Col>
        </Row>

        {showMap && (
          <>
            <Row>
              <Col span='12'>
                <DataItem label='Address'>{store.address}</DataItem>
              </Col>
              <Col span='12'>
                <DataItem label='Carrier Managed'>No</DataItem>
              </Col>
            </Row>
            <Row>
              <Col span='12'>
                <DataItem label='Hours'>{store.hours}</DataItem>
              </Col>
              <Col span='12'>
                <DataItem label='Carrier'>N/A</DataItem>
              </Col>
            </Row>
            <Row>
              <Col span='12'>
                <DataItem label='Phone'>{store.phone_number}</DataItem>
              </Col>
              <Col span='12'>
                <DataItem label='Market'>Duluth</DataItem>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  )
}
